// src/AppRoutes.js
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import TokenExpiredModal from './components/TokenExpiredModal';

// Le route protette (e tutte le loro pagine) non devono appesantire la schermata
// di login. Il relativo chunk viene richiesto solo dopo la navigazione.
const AppLayout = lazy(() => import('./AppLayout'));
// Anche il login è separato: si porta dietro Firebase Auth (~100 KB gzip), che
// a chi apre direttamente /dashboard con una sessione valida non serve.
const Home = lazy(() => import('./Views/home_View'));

const pageFallback = <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}><CircularProgress /></Box>;

const AppRoutes = ({ toggleDarkMode }) => {
  return (
    <Router>
      <TokenExpiredModal />
      <Suspense fallback={pageFallback}>
        <Routes>
          {/* Routes pubbliche */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Home />} />

          {/* Routes protette */}
          <Route
            path="/*"
            element={<AppLayout toggleDarkMode={toggleDarkMode} />}
          />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default AppRoutes;
